export default {"src":"/_next/static/media/angle-double-right.dbbcb6f8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};